import { queryOptions, useQuery } from '@tanstack/react-query';

import API from '@api';

/**
 * Рейтинг организации показывается в шапке и футере на каждой странице —
 * без кэша каждый инстанс дёргал API на каждый маунт (то есть на каждую
 * навигацию). Значение почти статичное — кэшируем на 10 минут.
 */
const ORGANIZATION_RATING_STALE_TIME = 10 * 60 * 1000;
const ORGANIZATION_RATING_GC_TIME = 15 * 60 * 1000;

export const organizationRatingQueryOptions = () =>
  queryOptions({
    queryKey: ['organizationRating'],
    queryFn: () => API.getOrganizationRating(),
    staleTime: ORGANIZATION_RATING_STALE_TIME,
    gcTime: ORGANIZATION_RATING_GC_TIME
  });

export const useOrganizationRatingQuery = () =>
  useQuery(organizationRatingQueryOptions());
